export const environment = {
    production: true,
    ApiBaseUrl: "https://appsvc-remitter-toolsapi-prod.azurewebsites.net/",
    EtlApiBaseUrl: "https://appsvc-remitter-etlapi-prod-brdqd9f6fmb5e3fp.westus-01.azurewebsites.net/",
    CampaignsApiUrl: 'https://campaignsapi.remitter.com/',
    CreditorPortalApiBaseUrl: "https://appsvc-remitter-creditorportalapi-prod.azurewebsites.net/"
};
